// Author Lin
// Date 2021-11-04 09:55:04

import * as model from "@/model/mintalMes/mst/MintalMesMstSubstationPointModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.MintalMesMstSubstationPoint(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_MINTALMES_MST_URL,
    })
    .buildStore()
